import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=35ebb518&scoped=true&"
var script = {}
import style0 from "./Collection.vue?vue&type=style&index=0&id=35ebb518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ebb518",
  null
  
)

export default component.exports